import { useEffect } from "react";
import { db } from "../../firebase/config";
import { setTournamentError } from "../../store/tournament/actions/setError";
import { TalesTournament } from "../types/TalesTournament";
import { setTournamentData } from "../../store/tournament/actions/setData";
import { useDispatch, useSelector } from "react-redux";
import { usedHooks } from "../../store/site/selectors";
import { addUsedHook } from "../../store/site/actions/addUsedHook";

export default function useTournaments() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useTournaments")) {
      dispatch(addUsedHook("useTournaments"));
      db.collection("tournament").onSnapshot((snapshot) => {
        if (snapshot.empty) {
          dispatch(setTournamentError("Non è stato trovato nessun torneo"));
        } else {
          let tournaments: TalesTournament[] = [];
          snapshot.docs.forEach((doc) => {
            tournaments = [...tournaments, doc.data() as TalesTournament];
          });
          dispatch(setTournamentData(tournaments));
        }
      });
    }
  }, [dispatch, hooks]);
}
